const POSITIVE_OPTIONS = [
  'RATING_POP_UP.POSITIVE.QUICKLY_FOUND',
  'RATING_POP_UP.POSITIVE.CLEAR_CONTENT',
  'RATING_POP_UP.POSITIVE.SIMPLE_EXPERIENCE',
  'RATING_POP_UP.POSITIVE.USEFUL_PLATFORM',
];

const NEUTRAL_OPTIONS = [
  'RATING_POP_UP.NEUTRAL.INCOMPLETE_INFO',
  'RATING_POP_UP.NEUTRAL.CLEARER_CONTENT',
  'RATING_POP_UP.NEUTRAL.SMOOTHER_EXPERIENCE',
  'RATING_POP_UP.NEUTRAL.MORE_USEFUL_PLATFORM',
];

const NEGATIVE_OPTIONS = [
  'RATING_POP_UP.NEGATIVE.NOT_FOUND',
  'RATING_POP_UP.NEGATIVE.UNCLEAR_CONTENT',
  'RATING_POP_UP.NEGATIVE.DIFFICULT_EXPERIENCE',
  'RATING_POP_UP.NEGATIVE.NOT_USEFUL_PLATFORM',
];

export { POSITIVE_OPTIONS, NEUTRAL_OPTIONS, NEGATIVE_OPTIONS };
